import axios from "@/request";
import qs from "qs";

export default {
  async list(params: any) {
    return axios.get("oplatform/app/list", { params });
  },
  async add(params: any) {
    return axios.post("oplatform/app/add", qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post("oplatform/app/edit", qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get("oplatform/app/detail", { params });
  },
  async delete(params: any) {
    return axios.post("oplatform/app/delete", qs.stringify(params));
  },
  async select(params: any) {
    return axios.get("oplatform/app/select", { params });
  },
  async subscribeReply(params: any) {
    return axios.get("oplatform/app/subscribe-reply", { params });
  },
  async saveSubscribeReply(params: any) {
    return axios.post("oplatform/app/save-subscribe-reply", qs.stringify(params));
  },
  async autoReply(params: any) {
    return axios.get("oplatform/app/auto-reply", { params });
  },
  async saveAutoReply(params: any) {
    return axios.post("oplatform/app/save-auto-reply", qs.stringify(params));
  },
  async menus(params: any) {
    return axios.get("oplatform/menus/list", { params });
  },
  async addmenu(params: any) {
    return axios.post("oplatform/menus/add", qs.stringify(params));
  },
  async editmenu(params: any) {
    return axios.post("oplatform/menus/edit", qs.stringify(params));
  },
  async getmenu(params: any) {
    return axios.get("oplatform/menus/detail", { params });
  },
  async deletemenu(params: any) {
    return axios.post("oplatform/menus/delete", qs.stringify(params));
  },
  async submitserver(params: any) {
    return axios.post("oplatform/menus/submitserver", qs.stringify(params));
  },
  async keywords(params: any) {
    return axios.get("oplatform/keywords/list", { params });
  },
  async addkeyword(params: any) {
    return axios.post("oplatform/keywords/add", qs.stringify(params));
  },
  async editkeyword(params: any) {
    return axios.post("oplatform/keywords/edit", qs.stringify(params));
  },
  async getkeyword(params: any) {
    return axios.get("oplatform/keywords/detail", { params });
  },
  async deletekeyword(params: any) {
    return axios.post("oplatform/keywords/delete", qs.stringify(params));
  },
  async news(params: any) {
    return axios.get("oplatform/news/list", { params });
  },
  async addnews(params: any) {
    return axios.post("oplatform/news/add", qs.stringify(params));
  },
  async editnews(params: any) {
    return axios.post("oplatform/news/edit", qs.stringify(params));
  },
  async getnews(params: any) {
    return axios.get("oplatform/news/detail", { params });
  },
  async deletenews(params: any) {
    return axios.post("oplatform/news/delete", qs.stringify(params));
  },
  async newsselect(params: any) {
    return axios.get("oplatform/news/select", { params });
  },
  async templatemessages(params: any) {
    return axios.get("oplatform/templatemessage/list", { params });
  },
  async addtemplatemessage(params: any) {
    return axios.post("oplatform/templatemessage/add", qs.stringify(params));
  },
  async edittemplatemessage(params: any) {
    return axios.post("oplatform/templatemessage/edit", qs.stringify(params));
  },
  async gettemplatemessage(params: any) {
    return axios.get("oplatform/templatemessage/detail", { params });
  },
  async deletetemplatemessage(params: any) {
    return axios.post("oplatform/templatemessage/delete", qs.stringify(params));
  },
  async templates(params: any) {
    return axios.get("oplatform/templates/list", { params });
  },
  async addtemplate(params: any) {
    return axios.post("oplatform/templates/add", qs.stringify(params));
  },
  async edittemplate(params: any) {
    return axios.post("oplatform/templates/edit", qs.stringify(params));
  },
  async gettemplate(params: any) {
    return axios.get("oplatform/templates/detail", { params });
  },
  async deletetemplate(params: any) {
    return axios.post("oplatform/templates/delete", qs.stringify(params));
  },
  async templateselect(params: any) {
    return axios.get("oplatform/templates/select", { params });
  },
  async fans(params: any) {
    return axios.get("oplatform/fans/list", { params });
  },
  async getfan(params: any) {
    return axios.get("oplatform/fans/detail", { params });
  },
  async addfan(params: any) {
    return axios.post("oplatform/fans/add", qs.stringify(params));
  },
  async editfan(params: any) {
    return axios.post("oplatform/fans/edit", qs.stringify(params));
  },
  async fansselect(params: any) {
    return axios.get("oplatform/fans/select", { params });
  },
  async deletefan(params: any) {
    return axios.post("oplatform/fans/delete", qs.stringify(params));
  },
  async groups(params: any) {
    return axios.get("oplatform/groups/list", { params });
  },
  async addgroup(params: any) {
    return axios.post("oplatform/groups/add", qs.stringify(params));
  },
  async editgroup(params: any) {
    return axios.post("oplatform/groups/edit", qs.stringify(params));
  },
  async getgroup(params: any) {
    return axios.get("oplatform/groups/detail", { params });
  },
  async deletegroup(params: any) {
    return axios.post("oplatform/groups/delete", qs.stringify(params));
  },
  async messages(params: any) {
    return axios.get("oplatform/messages/list", { params });
  },
  async weapps(params: any) {
    return axios.get("oplatform/weapp/list", { params });
  },
  async addweapp(params: any) {
    return axios.post("oplatform/weapp/add", qs.stringify(params));
  },
  async delweapp(params: any) {
    return axios.post("oplatform/weapp/delete", qs.stringify(params));
  },
  async searchStatus(params: any) {
    return axios.post("oplatform/weapp/search-status", qs.stringify(params));
  },
  async editweapp(params: any) {
    return axios.post("oplatform/weapp/edit", qs.stringify(params));
  },
  async detailweapp(params: any) {
    return axios.get("oplatform/weapp/detail", { params });
  },
  async deleteweapp(params: any) {
    return axios.post("oplatform/weapp/delete", qs.stringify(params));
  },
  async gettemplatedraftlist(params: any) {
    return axios.get("oplatform/weapp/gettemplatedraftlist", { params });
  },
  async addtotemplate(params: any) {
    return axios.post("oplatform/weapp/addtotemplate", qs.stringify(params));
  },
  async gettemplatelist(params: any) {
    return axios.get("oplatform/weapp/gettemplatelist", { params });
  },
  async deletecodetemplate(params: any) {
    return axios.post("oplatform/weapp/deletetemplate", qs.stringify(params));
  },
  async getQrcode(params: any) {
    return axios.get("oplatform/weapp/get-qrcode", { params });
  },
  async submitAudit(params: any) {
    return axios.post("oplatform/weapp/submit-audit", qs.stringify(params));
  },
  async release(params: any) {
    return axios.post("oplatform/weapp/release", qs.stringify(params));
  },
  async testers(params: any) {
    return axios.post("oplatform/weapp/testers", qs.stringify(params));
  },
  async bindTester(params: any) {
    return axios.post("oplatform/weapp/bind-tester", qs.stringify(params));
  },
  async unbindTester(params: any) {
    return axios.post("oplatform/weapp/unbind-tester", qs.stringify(params));
  },
  async plugin(params: any) {
    return axios.post("oplatform/weapp/plugin", qs.stringify(params));
  },
  async getaccountbasicinfo(params: any) {
    return axios.get("oplatform/weapp/getaccountbasicinfo", { params });
  },
  async modifydomain(params: any) {
    return axios.post("oplatform/weapp/modify-domain", qs.stringify(params));
  },
  async setwebviewdomain(params: any) {
    return axios.post("oplatform/weapp/setwebviewdomain", qs.stringify(params));
  },
  async commit(params: any) {
    return axios.post("oplatform/weapp/commit", qs.stringify(params));
  },
  async setnickname(params: any) {
    return axios.post("oplatform/weapp/setnickname", qs.stringify(params));
  },
  async modifyheadimage(params: any) {
    return axios.post("oplatform/weapp/modifyheadimage", qs.stringify(params));
  },
  async modifysignature(params: any) {
    return axios.post("oplatform/weapp/modifysignature", qs.stringify(params));
  },
  async getallcategories(params: any) {
    return axios.get("oplatform/weapp/getallcategories", { params });
  },
  async getcategoriesbytype(params: any) {
    return axios.post("oplatform/weapp/getcategoriesbytype", qs.stringify(params));
  },
  async getcategory(params: any) {
    return axios.get("oplatform/weapp/getcategory", { params });
  },
  async addcategory(params: any) {
    return axios.post("oplatform/weapp/addcategory", qs.stringify(params));
  },
  async deletecategory(params: any) {
    return axios.post("oplatform/weapp/deletecategory", qs.stringify(params));
  },
  async getLatestAuditstatus(params: any) {
    return axios.get("oplatform/weapp/get-latest-auditstatus", { params });
  },
  async materialList(params: any) {
    return axios.get("oplatform/media/material-list", { params });
  },
  async getwxasearchstatus(params: any) {
    return axios.get("oplatform/weapp/getwxasearchstatus", { params });
  },
  async changewxasearchstatus(params: any) {
    return axios.post("oplatform/weapp/changewxasearchstatus", qs.stringify(params));
  },
  async setprivacysetting(params: any) {
    return axios.post("oplatform/weapp/setprivacysetting", qs.stringify(params));
  },
  async getprivacysetting(params: any) {
    return axios.get("oplatform/weapp/getprivacysetting", { params });
  },
  async wxaauth(params: any) {
    return axios.post("oplatform/weapp/authorize", qs.stringify(params));
  },
  async wxaicp(params: any) {
    return axios.post("oplatform/weapp/apply-icp", qs.stringify(params));
  }
};
